import { collection, deleteDoc, doc, getDoc, getDocs, query, runTransaction, setDoc, updateDoc, where } from "firebase/firestore";
import { db } from "../../databases/firebase";

export const addNewDocumentToFS = async (value, arrayPath = []) => {
   return await setDoc(doc(db, ...arrayPath), value);
}

export const getAllDocumentsInsideCollection = async (routeArray) => await getDocs(collection(db, ...routeArray)); //.then(querySnapshot => querySnapshot.forEach(doc => doc.id, doc.data()))

export const getDataFromEachDocument = field => getAvailableDocumentsFSUpcomingChallenge()
   .then(_documentIDs =>  _documentIDs.map(val => getFieldValueFromFSUpcomingChallenge(val, field))) //Returns an array with each element being a promise.
   .then(promise => Promise.all(promise)) //Promise.all iterates through each element.
   .then(data => data) //data is an array of each promise (if resolved).
   .catch(error => console.error({ error, errorCode: error.code, errorMessage: error.message })); //If the promise from Promise.all is unresolved.

export async function getFieldValueFromFSUpcomingChallenge(_challengeID, fieldValue) {
   const docRef = doc(db, "internet-idol-faceoff", "Challenges", "challengeAnnouncements", _challengeID);
   const docSnap = await getDoc(docRef);

   try {
      if (docSnap.exists() && docSnap.data()[fieldValue]) {
         console.log({ message: "YEAH!!! Document exists.", fieldValueMatches: docSnap.data()[fieldValue], data: docSnap.data() })
      } else {
         console.error({ message: "Sorry... no such document", fieldValueMatches: false, data: docSnap.data() });
      }
   } catch (error) {
      console.error({ origin: "getFieldValueFromFS function.", error, errorCode: error.code, errorMessage: error.message });
   } finally {      
      return { _challengeID, allData: docSnap.data(), requestedFieldValue: docSnap.data()[fieldValue] } || null;
   }
}

export async function findChallengeInFirestore(challengeType, _challengeID) {
   const docRef = doc(db, "internet-idol-faceoff", "Challenges", challengeType, _challengeID);

   const docSnap = await getDoc(docRef);
   return docSnap.exists && docSnap.data();
}

export async function findChallengeInFirestoreII(challengeType, _challengeID) {
   const docRef = doc(db, "internet-idol-faceoff", "Challenges", challengeType, _challengeID);

   const docSnap = await getDoc(docRef)

   return new Promise((res, rej) => {
      if (docSnap.data()) {
         res({ message: "Successfully extracted data!!!", docSnap: docSnap.data() })
      } else {
         rej({ message: "No data extracted...", docSnap: docSnap.data() })
      }
   })
}

export async function getMultipleFieldValuesFromFSUpcomingChallenge(_challengeID, newKey, newValue) {
   const updateDocRef = doc(db, "internet-idol-faceoff", "Challenges", "challengeAnnuncements", _challengeID);
   try {
      const updatedData = await runTransaction(db, async (transaction) => {
         const updateDoc = await transaction.get(updateDocRef);
         if (!updateDoc.exists()) {
            console.error("document does not exist!!!");
         }
         console.log({ updateDocData: updateDoc.data() });

         return updateDoc.data();
      })
   } catch (err) {
      
   }
}

export async function getAvailableDocumentsFSUpcomingChallenge(optionalState = null, optionalSetState = null) {
   const documentIDs = []
   try {
      const challengeQuery = query(collection(db, "internet-idol-faceoff", "Challenges", "challengeAnnouncements"));
      
      const challengeQuerySnapshot = await getDocs(challengeQuery);
      challengeQuerySnapshot.forEach(doc => {
         documentIDs.push(doc.id); //We push each document id into documentIDs array.
         (optionalState && optionalSetState) && optionalSetState(prvState => ([...prvState, doc.id]));
      })
   } catch (error) {
      console.error({ origin: "getAvailableDocumentsFSUpcomingChallenge function", error, errorCode: error.code, errorMessage: error.message });
   } finally {
      return documentIDs; //returns documentIDs array of (hopefully) documentIDs.
   }
}

export async function updateActiveChallengeInFS(_challengeID, newObject) {
   const updateDocRef = doc(db, "internet-idol-faceoff", "Challenges", "activeChallenges", _challengeID);

   return updateDoc(updateDocRef, { ...newObject });
}

export async function updateChallengeAnnouncementInFS(_challengeID, newObject) {
   const updateDocRef = doc(db, "internet-idol-faceoff", "Challenges", "challengeAnnouncements", _challengeID);

   return updateDoc(updateDocRef, { ...newObject });
}

export async function updateVideoInFS(documentID, updatedObject) {
   const targetVideoRef = doc(db, "internet-idol-faceoff", "Videos", "allVideos", documentID);

   return updateDoc(targetVideoRef, { ...updatedObject }); //This is a Promise.
} 

export const updateDocumentInFireStore = async (updatedObject, docPath) => {
   const docRef = doc(db, ...docPath);
   return updateDoc(docRef, { ...updatedObject }); //This is a Promise.
}

export const getAllDocumentIDFromFirestore = docPath => {
   return getDocs(collection(db, ...docPath));
}

export const filterDocumentsInFS = async (docPath, selector, value) => {
   var filteredArray = [];
   const q = query(collection(db, ...docPath), where(selector, "==", value));
   const querySnapshot = await getDocs(q);
   querySnapshot.forEach(doc => filteredArray = [...filteredArray, doc.data()]);

   return new Promise((res, rej) => {
      if (filteredArray.length) {
         res(filteredArray);
      } else {
         rej({ message: `ERROR!!! Filtered array returned no matches where ${selector} == ${value}!!!`, filteredArray });
      }
   })
}

export const updateAllDocumentsInFS = async (updatedObject, docPath) => {
   let arrayOfPromises = [];
   const querySnapshot = await getAllDocumentIDFromFirestore(docPath);

   querySnapshot.forEach(document => {
      const documentIDpath = [...docPath, document.id];
      const docRef = doc(db, ...documentIDpath);
      arrayOfPromises = [...arrayOfPromises, updateDoc(docRef, { ...updatedObject })];
   })

   return arrayOfPromises;
}

export const deleteAllDocuments = async () => {
   const querySnapshot = await getDocs(collection(db, "internet-idol-faceoff", "Challenges", "completedChallenges"));
   querySnapshot.forEach(async document => await deleteDoc(doc(db, "internet-idol-faceoff", "Challenges", "completedChallenges", document.id)));
}

export const endActiveChallengeProcess = () => {
   //Update record for each video.

   //Remove challenge from active challenge.

   //Add challenge to completed challenge.
}